import { graphql } from '@/client/services/api/graphql/gql';

export const getUserDashboardHeroImageQuery = graphql(`
  query GetUserDashboardHeroImage($id: String!) {
    user(id: $id) {
      dashboardHeroImage
    }
  }
`);
